const hostsSection = $('#hosts-section');
const hostsCardsOverflow = hostsSection.find('.hosts-list-overflow');
const hostsCardsList = hostsSection.find('.hosts-list');
const overflowWidth = pxToVw(hostsCardsOverflow.width());
const hostsCards = hostsSection.find('.host-card');
const controlsBtn = hostsSection.find('.arrow-nav');
const playWebinarBtn = hostsSection.find('.hosts-webina-card-play-btn');
const leftOffsetsVw = hostsCards
  .map(function (index, el) {
    return pxToVw($(el).position().left);
  })
  .get();

const lastCard = hostsCards.last();
const lastCardRight = pxToVw(lastCard.position().left + lastCard.outerWidth(true));
const maxOffset = lastCardRight - overflowWidth + 3.75;
CustomEase.create('scrollEase', '0.60, 0.00, 0.40, 1.00');

playWebinarBtn.on('click', function () {
  /*
  lenis.scrollTo('.webinar-cover-parent', {
    offset: -vwToPx(1.875),
    onComplete: () => {
      $('.webinar-cover-image').fadeOut(300);
      $('.webinar-cover-play-icon').fadeOut(300);
      webinarPlayer.playVideo();
    },
  });
  */
});

const scrollCards = (current, direction) => {
  const currentOffset = leftOffsetsVw[current];
  const staggerDirection = direction == 1 ? 'start' : 'end';
  const finalOffset = Math.min(maxOffset, currentOffset);
  btnStateControl(current, finalOffset == maxOffset ? current : undefined);

  gsap.to(hostsCards, {
    x: `-${finalOffset}vw`,
    duration: 0.833,
    ease: 'scrollEase',
    stagger: {
      each: 0.1,
      from: staggerDirection,
    },
  });
};

const btnStateControl = (current, lastCard) => {
  controlsBtn.eq(0).prop('disabled', current == 0);
  controlsBtn.eq(1).prop('disabled', current == lastCard);
};

const addCardsControl = () => {
  if (pxToVw(hostsCardsList.outerWidth()) >= 100) {
    gsap.set($('.hosts-nav-placer'), { display: 'flex' });
    let currentCardIndex = 0;
    btnStateControl(0, undefined);
    controlsBtn.on('click', function () {
      const direction = $(this).is(controlsBtn.eq(0)) ? -1 : 1;
      currentCardIndex += direction;
      scrollCards(currentCardIndex, direction);
    });
  }
};

const hostsCardIn = () => {
  const hostsCardInnTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      btnArrowHoverAnimation(controlsBtn);
    },
  });
  hostsCards.each(function (index) {
    hostsCardInnTL.add(
      gsap.fromTo(
        $(this),
        {
          x: `${overflowWidth}vw`,
        },
        {
          x: 0,
          duration: 1.3,
          ease: 'scrollEase',
        }
      ),
      index * 0.1
    );
  });

  return hostsCardInnTL;
};

const hostsSectionIn = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #959698ff 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const sectionInTL = gsap.timeline({
    paused: true,
  });

  sectionInTL.add(
    animateSectionTopperIn({
      sectionParent: hostsSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );

  return sectionInTL;
};

const initWebinarHosts = () => {
  const hostsInTL = hostsSectionIn();
  const hostCardsInTL = hostsCardIn();
  ScrollTrigger.create({
    trigger: hostsSection,
    start: 'top top+=120%',
    end: 'top top+=20%',
    once: true,
    onUpdate: (self) => {
      hostsInTL.progress(self.progress);
    },
  });
  ScrollTrigger.create({
    trigger: hostsSection,
    start: 'top top+=70%',
    end: 'top center',
    once: true,
    onLeave: () => {
      hostCardsInTL.play();
    },
  });
}

/*
$(window).on('load', () => {
  initWebinarHosts();
});
*/

addSectionObserver(hostsSection, initWebinarHosts, false);
addSectionObserver(hostsSection, addCardsControl);